module.exports = __webpack_public_path__ + "static/img_0-93337d6ad9beb9227c5a6cc9371a24db.png";